import { render, staticRenderFns } from "./list-forms.vue?vue&type=template&id=f7137ca4"
import script from "./list-forms.vue?vue&type=script&lang=js"
export * from "./list-forms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports